// extracted by mini-css-extract-plugin
module.exports = {"symbolImage":"ProductSymbols_symbolImage__1xf05"};